export const ChevronRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={10} height={10} viewBox="0 0 10 12" fill="none">
    <path d="M2.91406 1.41666L6.92448 5.99999L2.91406 10.5833" stroke="black" strokeLinecap="round"/>
  </svg>
)
